module.exports = __webpack_public_path__ + "img/ecommerce-card-bg.0f7bfcc4.png";